import React from "react";

import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useForm } from "react-hook-form";

//import _uniqueId from "lodash/uniqueId";

import { useSelector, useDispatch } from "react-redux";
import { addTag } from "../../features/personalDatabaseSlice";
import OurTextField from "../forms/OurTextField";

export default function AddTagDialogue(props) {
  const personalDatabaseContents = useSelector(
    (state) => state.personalDatabase.contents
  );
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  //const [dbPassword, setDbPassword] = useState('');

  const {
    //setValue,
    clearErrors,
    handleSubmit,
    //watch,
    formState: { errors },
    control,
    reset,
  } = useForm();

  const handleClickOpen = () => {
    setOpen(true);
  };

  //const [id] = useState(_uniqueId("prefix-"));
  /*
  React.useEffect(() => {
    triggerRef.current = handleClickOpen
  }, [])
  // PREP to create link-back to the dialogue open function
  // https://dilshankelsen.com/call-child-function-from-parent-component-in-react/
  */

  const handleClose = () => {
    clearErrors();
    reset();
    setOpen(false);
  };

  const onSubmit = (data) => {
    console.log(data);

    // generate unique ID - largest?
    let largestIdSofar = 0;

    // iterate through all - no guarantees re. ordering
    personalDatabaseContents.tags.forEach(function (tag, index) {
      console.log(index);
      largestIdSofar = Math.max(largestIdSofar, tag.id);
    });

    dispatch(
      addTag({
        id: largestIdSofar + 1,
        name: data.tagName,
      })
    );

    handleClose();
  };

  return (
    <>
      <Button variant="contained" component="div" onClick={handleClickOpen}>
        Add Tag
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Add Tag</DialogTitle>
          <DialogContent>
            <DialogContentText>Please specify Tag name</DialogContentText>
            <OurTextField
              autoFocus={true}
              fieldName="tagName"
              control={control}
              errors={errors}
              label="Name"
              maxLength={500}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit(onSubmit)}>Add Tag</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
